/* eslint-disable no-unused-vars */
import { axios } from '@/repositories'

const resource = '/v1/stay'
const resource_user = '/v1/users'

export default {
  async updateProfile(data) {
    return new Promise((resolve, reject) => {
      axios.put(`${resource}/profile/me`, data).then(
        (response) => {
          resolve(response.data)
        },  
        (error) => {
          reject(error)
        }
      ).catch(() => {
      })
    })
  },
  async getFavoriteArea(data) {
    return new Promise((resolve, reject) => {
      axios.get(`${resource}/city-list`).then(
        (response) => {
          resolve(response.data)
        },  
        (error) => {
          reject(error)
        }
      )
    })
  },
  async getFavoriteLocation(data) {
    return new Promise((resolve, reject) => {
      axios.get(`${resource}/interest/location`).then(
        (response) => {
          resolve(response.data)
        },  
        (error) => {
          reject(error)
        }
      )
    })
  },
  async addFavoriteArea(data) {
    return new Promise((resolve, reject) => {
      axios.post(`${resource}/interest/location`, data).then(
        (response) => {
          resolve(response.data)
        },  
        (error) => {
          reject(error)
        }
      )
    })
  },
  async getInterestList(data) {
    return new Promise((resolve, reject) => {
      axios.get(`${resource}/interest`, data).then(
        (response) => {
          resolve(response.data)
        },  
        (error) => {
          reject(error)
        }
      )
    })
  },
  async addInterestList(data) {
    return new Promise((resolve, reject) => {
      axios.post(`${resource}/interest`, data).then(
        (response) => {
          resolve(response.data)
        },  
        (error) => {
          reject(error)
        }
      )
    })
  }
}

